import { useState, useEffect } from 'react';

import browser from '@openclassrooms/utils/browser';

const DEFAUT_SCROLL_OFFSET_TRIGGER = 300;
const SCROLL_TO_OPTIONS = { top: 0, behavior: 'smooth' };
const SCROLL_DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};
const isScrollBeyondOffset = (offset) => {
  const scrolledDistance = browser.document.documentElement.scrollTop;
  return scrolledDistance > offset;
};

/* istanbul ignore next */
function getDefaultScrollOffsetTrigger() {
  return browser.window?.innerHeight ?? DEFAUT_SCROLL_OFFSET_TRIGGER;
}

const useScrollTop = ({
  scrollOffsetTrigger = getDefaultScrollOffsetTrigger(),
  scrollToOptions = SCROLL_TO_OPTIONS,
}) => {
  const [isBeyondOffset, setIsBeyondOffset] = useState(isScrollBeyondOffset(scrollOffsetTrigger));
  const [scrollDirection, setScrollDirection] = useState();

  useEffect(() => {
    let lastScrollY = browser.window.scrollY;
    let ticking = false;

    const updateVisibility = () => {
      const { scrollY } = browser.window;
      setScrollDirection(scrollY > lastScrollY ? SCROLL_DIRECTION.DOWN : SCROLL_DIRECTION.UP);
      setIsBeyondOffset(isScrollBeyondOffset(scrollOffsetTrigger));
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        browser.window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    };

    browser.window?.addEventListener('scroll', onScroll);
    return () => {
      browser.window?.removeEventListener('scroll', onScroll);
    };
  }, []);

  const isVisible = isBeyondOffset && scrollDirection === SCROLL_DIRECTION.UP;

  return {
    isVisible,
    handleScrollTop: function handleScrollTop() {
      /* istanbul ignore next */
      if (!isVisible) {
        return;
      }
      browser.window?.scrollTo(scrollToOptions);
    },
  };
};

export default useScrollTop;
